<template>
    <el-dialog
        :title="(isForm ? (modelId ? '编辑' : '添加') : '查看') + dialogTitle"
        :model-value="modelValue"
        top="10vh"
        width="640px"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="isForm ? formRules : {}"
            label-width="150px"
            label-suffix="："
            style="max-width: 560px"
        >
            <el-form-item label="户名">
                <el-input
                    v-if="isForm"
                    v-model="room_detail.household"
                    placeholder="请输入户名"
                    clearable
                    :disabled="houseNameDisabled"
                ></el-input>
                <span v-else>{{ room_detail.household }}</span>
            </el-form-item>
            <el-form-item label="联系电话">
                <el-input
                    v-if="isForm"
                    v-model="room_detail.phone"
                    placeholder="请输入联系电话"
                    clearable
                    :disabled="houseNameDisabled"
                ></el-input>
                <span v-else>{{ room_detail.phone }}</span>
            </el-form-item>
            <el-form-item label="型号" prop="model">
                <el-cascader
                    v-if="isForm"
                    :emitPath="false"
                    filterable
                    clearable
                    v-model="formData.model"
                    :options="model_tree"
                    :props="{
                        expandTrigger: 'hover',
                        emitPath: false,
                        label: 'name',
                        value: 'id'
                    }"
                    style="width: 100%"
                />
                <span v-else>
                    {{ formData.model ? model_list[formData.model].type + ' / ' + model_list[formData.model].model : '' }}
                </span>
            </el-form-item>
            <el-form-item label="IMEI" prop="IMEI">
                <el-input v-if="isForm" v-model="formData.IMEI" placeholder="请输入设备IMEI" clearable></el-input>
                <span v-else>{{ formData.IMEI }}</span>
            </el-form-item>
            <el-form-item label="安装位置" prop="room">
                <el-cascader
                    v-if="isForm"
                    filterable
                    clearable
                    v-model="formData.room"
                    :options="room_tree"
                    :props="{
                        expandTrigger: 'hover',
                        emitPath: false,
                        label: 'name',
                        value: 'id'
                    }"
                    style="width: 100%"
                    @change="handleChangeRoom"
                />
                <span v-else>{{ room_list[formData.room] }}</span>
            </el-form-item>
            <el-form-item label="详细位置" prop="location">
                <el-input v-if="isForm" v-model="formData.location" placeholder="请输入详细位置" clearable></el-input>
                <span v-else>{{ formData.location }}</span>
            </el-form-item>
            <el-form-item v-if="!isForm" label="首次注册时间" prop="reg_ts">
                <span>{{ formData.reg_ts }}</span>
            </el-form-item>
            <el-form-item v-if="!isForm" label="版本" prop="version">
                <span>{{ formData.version }}</span>
            </el-form-item>
            <el-form-item v-if="!isForm" label="ICCID" prop="ICCID">
                <span>{{ formData.ICCID }}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer" v-if="isForm">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
            <span class="dialog-footer" v-else>
                <el-button type="primary" @click="closed">关闭</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { editDeviceInfo } from '@/api/heating/devicePoint/devicePoint.js'
import { ElMessage } from 'element-plus'
import { getOptionTree } from '@/api/room.js'
import { getEquipModelTree } from '@/api/equipment.js'
import { getRoomDetail } from '@/api/building'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    modelId: {
        type: String,
        required: false
    },
    detailData: {
        type: Object,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
const room_detail = ref({
    household: '',
    phone: ''
})
const houseNameDisabled = ref(false)
const getHouseNameFn = async (room_id) => {
    room_detail.value = await getRoomDetail(room_id)
    if (room_detail.value.household || room_detail.value.phone) {
        houseNameDisabled.value = true
    } else {
        houseNameDisabled.value = false
    }
}
const handleChangeRoom = (data) => {
    if (data) {
        getHouseNameFn(data)
    }
}
// 型号列表
const model_tree = ref([])
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        model_tree.value = data
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_tree = ref([])
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        room_tree.value = data
        const room_locations = {}
        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }
        getRoom(data, '')
        room_list.value = room_locations
    })
}

// 表单源
const formData = ref({
    id: '',
    name: '',
    phone: '',
    model: '',
    IMEI: '',
    building: '',
    room: '',
    location: '',
    version: '',
    ICCID: ''
})

// 验证规则

const formRules = ref({
    phone: [
        {
            required: false,
            trigger: 'blur',
            validator: (rule, value, callback) => {
                if (value === '') {
                    callback()
                } else if (!/^1[3-9]\d{9}$/.test(value)) {
                    callback(new Error('手机号格式不正确'))
                } else {
                    callback()
                }
            }
        }
    ],
    IMEI: [
        {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
                // IMEI必须为15位纯数字，且为必填项
                console.log(value)
                if (value === '') {
                    callback(new Error('请输入设备IMEI'))
                } else if (!/^[0-9]{15}$/.test(value)) {
                    callback(new Error('IMEI必须为15位纯数字'))
                } else {
                    callback()
                }
            }
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.modelId !== '') {
        await handleEdit()
    }
}

// 修改
const handleEdit = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const data = { type: 3, ...formData.value }
        if (room_detail.value.household) {
            data.household = room_detail.value.household
        }
        if (room_detail.value.phone) {
            data.phone = room_detail.value.phone
        }
        try {
            await editDeviceInfo(data)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

const loading = ref(false)

onMounted(async () => {
    loading.value = true
    await getModelList()
    await getRoomTree()

    if (props.modelId) {
        const obj = { ...formData.value }
        Object.keys(props.detailData).forEach((key) => {
            if (key in obj) {
                obj[key] = props.detailData[key]
            }
        })
        if (props.detailData.room) {
            await getHouseNameFn(props.detailData.room)
        }
        formData.value = obj
        loading.value = false
    } else {
        formData.value = {
            id: '',
            name: '',
            phone: '',
            model: '',
            IMEI: '',
            building: '',
            room: '',
            version: '',
            ICCID: ''
        }
    }
})
</script>

<style scoped></style>
